const Button = (props) => {
    return (
        <button onClick={props.onClick} className='bg-white rounded-lg px-6 py-4 text-black font-bold tracking-tight'>
            {props.label}
        </button>
    );
}

export default Button;